import { createHook, createSubscriber } from '@atlassian/eoc-rss-helpers';

import { type actions } from '../actions';
import { store } from '../index';
import { selectors } from '../selectors';
import { type initialState } from '../state';

const useStep = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getStep>
>(store, {
	selector: selectors.getStep,
});

const useDetailVariant = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getDetailVariant>
>(store, {
	selector: selectors.getDetailVariant,
});

const useOrderRotationLoading = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getOrderRotationLoading>
>(store, {
	selector: selectors.getOrderRotationLoading,
});

const useRecipientUpdate = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getRecipientUpdate>
>(store, {
	selector: selectors.getRecipientUpdate,
});

const useInitialRotation = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getInitialRotation>
>(store, {
	selector: selectors.getInitialRotation,
});

const StepSubscriber = createSubscriber(store, {
	selector: selectors.getStep,
});

export {
	useStep,
	useDetailVariant,
	useRecipientUpdate,
	useInitialRotation,
	useOrderRotationLoading,
	StepSubscriber,
};
